import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const ShareIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="share icon">
      {/* <title>share icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9668 4.38462C15.9724 4.38462 15.1669 5.19012 15.1669 6.18459C15.1669 7.17906 15.9724 7.98456 16.9668 7.98456C17.9613 7.98456 18.7668 7.17906 18.7668 6.18459C18.7668 5.19012 17.9613 4.38462 16.9668 4.38462ZM13.7823 6.18459C13.7823 4.42542 15.2077 3 16.9668 3C18.726 3 20.1514 4.42542 20.1514 6.18459C20.1514 7.94376 18.726 9.36917 16.9668 9.36917C15.2077 9.36917 13.7823 7.94376 13.7823 6.18459ZM6.99806 10.1996C6.0036 10.1996 5.19809 11.0051 5.19809 11.9995C5.19809 12.9941 6.0036 13.7995 6.99806 13.7995C7.99253 13.7995 8.79804 12.9941 8.79804 11.9995C8.79804 11.0051 7.99253 10.1996 6.99806 10.1996ZM3.81348 11.9995C3.81348 10.2404 5.2389 8.81497 6.99806 8.81497C8.75724 8.81497 10.1827 10.2404 10.1827 11.9995C10.1827 13.7587 8.75724 15.1842 6.99806 15.1842C5.2389 15.1842 3.81348 13.7587 3.81348 11.9995ZM16.9668 16.0155C15.9724 16.0155 15.1669 16.821 15.1669 17.8154C15.1669 18.8092 15.9726 19.6154 16.9668 19.6154C17.9611 19.6154 18.7668 18.8092 18.7668 17.8154C18.7668 16.821 17.9613 16.0155 16.9668 16.0155ZM13.7823 17.8154C13.7823 16.0563 15.2077 14.6309 16.9668 14.6309C18.726 14.6309 20.1514 16.0563 20.1514 17.8154C20.1514 19.5735 18.7262 21 16.9668 21C15.2075 21 13.7823 19.5735 13.7823 17.8154Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4117 7.08988C15.6043 7.42013 15.4928 7.84404 15.1627 8.03673L9.49635 11.3427C9.16613 11.5354 8.74221 11.4239 8.54953 11.0937C8.35684 10.7634 8.46836 10.3394 8.79861 10.1468L14.4648 6.84079C14.7951 6.6481 15.2191 6.75962 15.4117 7.08988ZM8.55023 12.9051C8.74275 12.5748 9.16661 12.4631 9.49699 12.6556L15.1712 15.9624C15.5016 16.155 15.6134 16.5789 15.4208 16.9092C15.2283 17.2395 14.8044 17.3513 14.4741 17.1587L8.79978 13.8519C8.46944 13.6594 8.35771 13.2355 8.55023 12.9051Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default ShareIcon;
